import { CarouselHeaderPropsType, RelatedFilmItem, RelatedFilmsPropsType } from '../../../../types'

import { Header } from '../Header'
import { Slide } from './Slide'
import { SwiperReactFacade } from '../../'
import cls from 'classnames';
import { fourColSettings } from '../..'
import { md5 } from '../../../../utils'
import React from 'react';

export const RelatedFilmsCarouselComponent: React.FC<RelatedFilmsPropsType> = props => {
    const { displayText, workflow } = props
    const  items = displayText.filmItems.map( item => ({...item, key: uuid(item), workflow: workflow}))
    const options = fourColSettings(displayText.filmItems.length)
    const hideArrows = items.length <= 4

    const headerProps: CarouselHeaderPropsType = {
        title: displayText.title
    }

    const numberOfSlidesClass = cls({
        'film-carousel__single-slide': items.length === 1
    })
    
    return (
        <div className="width--normal padding--add">
            <div className={`film-carousel__wrap ${numberOfSlidesClass}`}>
                <Header {...headerProps} />
                <SwiperReactFacade options={options} hideArrows={hideArrows} className="film-carousel related-film-carousel">
                    {items.map(filmItem => <Slide {...filmItem} key={filmItem.key} />)}
                </SwiperReactFacade>
            </div>
        </div>
        
    )
}

function uuid(item: RelatedFilmItem) {
    return md5(
        item.filmId +
        item.title
    )
}

export default RelatedFilmsCarouselComponent